// extracted by mini-css-extract-plugin
module.exports = {"toggleIconButton":"ToggleIconButton_toggleIconButton__S1a5V","active":"ToggleIconButton_active__X0_mC"};